const offsets = {
  sectionVertical: '100px',
  sectionHorizontal: '194px',
  medium: '24px',
  large: '40px',
  extraLarge: '60px',
} as const;

export default offsets;
